import { Bar, BarChart as RechartsBarChart, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts";
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "./chart";

export interface BarChartProps {
  data: Array<Record<string, any>>;
  index: string;
  categories: string[];
  valueFormatter?: (value: number) => string;
  colors?: string[];
  className?: string;
  showGrid?: boolean;
}

export function BarChart({
  data,
  index,
  categories,
  valueFormatter = (value: number) => `${value}`,
  colors = [
    "hsl(var(--chart-1))",
    "hsl(var(--chart-2))",
    "hsl(var(--chart-3))",
    "hsl(var(--chart-4))",
    "hsl(var(--chart-5))",
  ],
  className,
  showGrid = true,
}: BarChartProps) {
  const chartConfig: ChartConfig = {};

  categories.forEach((category, i) => {
    chartConfig[category] = {
      label: category,
      color: colors[i % colors.length],
    };
  });

  return (
    <ChartContainer config={chartConfig} className={className}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsBarChart data={data} margin={{ top: 15, right: 15, left: 15, bottom: 25 }}>
          {showGrid && <CartesianGrid strokeDasharray="3 3" vertical={false} />}
          <XAxis
            dataKey={index}
            axisLine={false}
            tickLine={false}
            tick={{ fill: "var(--muted-foreground)", fontSize: 12 }}
            height={40}
            tickMargin={8}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "var(--muted-foreground)", fontSize: 12 }}
            width={40}
            tickMargin={8}
            tickFormatter={(value) => valueFormatter(value)}
          />
          <ChartTooltip
            content={
              <ChartTooltipContent
                formatter={(value, name) => {
                  return [valueFormatter(Number(value)), name];
                }}
              />
            }
          />
          {categories.map((category, index) => (
            <Bar
              key={category}
              dataKey={category}
              fill={colors[index % colors.length]}
              radius={[4, 4, 0, 0]}
              maxBarSize={50}
            />
          ))}
        </RechartsBarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
}
